module.exports = __webpack_public_path__ + "static/background-hero-md-6181a2b585698c2ee3fd1bd1c1afcd78.png";